import { GET_ASSESSMENT_BY_ID_SUCCESS, GET_ASSESSMENTS_SUCCESS } from './assessment.types';

const initialState = {
    assessmentList: [],
    assessmentById: null,
};

export const assessmentReducer = (state = initialState, action) => {
    switch (action.type) {
        /** Assessment */

        case GET_ASSESSMENTS_SUCCESS:
            return {
                ...state,
                assessmentList: action.payload,
            };

        case GET_ASSESSMENT_BY_ID_SUCCESS:
            return {
                ...state,
                assessmentById: action.payload,
            };

        /** End */

        default:
            return state;
    }
};
